import * as React from 'react';
import { Box } from '../Box';
import { globalSizes } from '../common/globalSizes';
import * as styles from './Cover.module.css';

// TODO: make header/footer/centered genuinely optional so callers don't pass
// empty placeholder nodes (e.g. footer={<div />}). The CSS relies on the
// :first-child/:last-child :not(.centered) guards, so absent slots need handling
// there. Also: `centered.props` assumes centered is always defined — guard it.
// TODO: prefer a self-contained height (box-sizing: border-box + min-block-size:
// 100dvh with own padding) over callers passing a minHeight that bakes in the
// parent's padding.
export const Cover = React.forwardRef(function Cover(
  {
    centered,
    className = '',
    footer,
    gap = 'none',
    header,
    minHeight = '100vh',
    padding = 'none',
    style = {},
    ...rest
  },
  ref,
) {
  const combinedContainerClasses = [styles.cover, className]
    .filter(Boolean)
    .join(' ');

  const combinedCenteredClasses = [styles.centered, centered.props.className]
    .filter(Boolean)
    .join(' ');

  const centeredContent =
    centered &&
    React.cloneElement(centered, { className: combinedCenteredClasses });

  const combinedStyles = {
    '--gap': globalSizes[gap],
    '--minHeight': minHeight,
    ...style,
  };

  return (
    <Box
      className={combinedContainerClasses}
      padding={padding}
      ref={ref}
      style={combinedStyles}
      {...rest}
    >
      {header}
      {centeredContent}
      {footer}
    </Box>
  );
});
